// extracted by mini-css-extract-plugin
export default {"wrapper":"Ss","subscription":"Ts","select_item":"Us","is_selected":"Vs","otb":"Ws","radio":"Xs","first_row":"Ys","prices":"Zs","italic":"at","info_wrapper":"bt","first_month":"ct","separator":"et","checkmark":"ft","bullets":"gt","bullet":"ht","checkmarkText":"it","button":"jt","discountBadge":"kt"};
    if(module.hot) {
      // 1713969925881
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  